<template lang="pug">
  .container
    .card
      cadastro-processo-fisico(titleCadastro="Solicitar processo físico", routeName="central/processo-fisico", :cadastroEmpty="empty", :tabs="tabs")
</template>

<script>
import CadastroProcessoFisico from '@/screens/central/components/CadastroProcessoFisico'
import empty from '../empty/emptyProcessoFisico'

export default {

  components: {
    CadastroProcessoFisico
  },

  data () {
    return {
      tabs: [
        {
          label: 'Cadastrante',
          name: this.$route.path.split('/')[1] + '/processo-fisico/cadastrante',
          codigo: 'CADASTRANTE'
        },
        {
          label: 'Interessado',
          name: this.$route.path.split('/')[1] + '/processo-fisico/interessado',
          codigo: 'INTERESSADO'
        },
        {
          label: 'Imóvel',
          name: this.$route.path.split('/')[1] + '/processo-fisico/imovel',
          codigo: 'IMOVEL'
        },
        {
          label: 'Resumo',
          name: this.$route.path.split('/')[1] + '/processo-fisico/resumo',
          isResumo: true
        }
      ],
      empty: empty
    }
  }

}
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  .card {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/maranhao/processoFisico/Cadastro.vue